<table class="lv-fonds-table" mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="anteil">
    <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell">Anteil</th>
    <td mat-cell *matCellDef="let element; let row=index"
        [ngClass]="{'lv-fonds-anlauf-ablauf-last-row': (row === dataSource.data.length-1 && isLastRowBold)}"
        class="lv-fonds-table-data-cell lv-fonds-table-data-cell-anteil">
      {{element.prozentualerAnteil}} %
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell">Fondsname / ISIN</th>
    <td mat-cell *matCellDef="let element; let row=index"
        [ngClass]="{'lv-fonds-anlauf-ablauf-last-row': (row === dataSource.data.length-1 && isLastRowBold)}"
        class="lv-fonds-table-data-cell lv-fonds-table-cell-width-425">
      {{element.name}} <br> {{element.isin}}
    </td>
  </ng-container>
  <ng-container matColumnDef="risikoklasse">
    <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell">SRI</th>
    <td mat-cell *matCellDef="let element; let row=index"
        [ngClass]="{'lv-fonds-anlauf-ablauf-last-row': (row === dataSource.data.length-1 && isLastRowBold)}"
        class="lv-fonds-table-data-cell">
      {{element.risikoklasse}}
    </td>
  </ng-container>
  <ng-container matColumnDef="factsheet">
    <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">Factsheet</th>
    <td mat-cell *matCellDef="let element let row=index"
        [ngClass]="{'lv-fonds-anlauf-ablauf-last-row': (row === dataSource.data.length-1 && isLastRowBold)}"
        class="lv-fonds-table-data-cell lv-fonds-table-icon">
      <ng-container *ngIf="!!element.factsheet">
        <a href="{{element.factsheet}}" target="_blank"><mat-icon [svgIcon]="'DownloadToLine'"></mat-icon></a>
      </ng-container>
    </td>
  </ng-container>
  <ng-container matColumnDef="esgreport">
    <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">ESG-Report</th>
    <td mat-cell *matCellDef="let element let row=index"
        [ngClass]="{'lv-fonds-anlauf-ablauf-last-row': (row === dataSource.data.length-1 && isLastRowBold)}"
        class="lv-fonds-table-data-cell lv-fonds-table-icon">
      <ng-container *ngIf="!!element.esgreport">
        <a href="{{element.esgreport}}" target="_blank"><mat-icon [svgIcon]="'DownloadToLine'"></mat-icon></a>
      </ng-container>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

